<div class="modal-content">
  <div class="text-right">
    <mat-icon (click)="onSubmit(false)">close</mat-icon>
  </div>
  <div class="content" *ngIf="nextStep">
    <div class="text-center mt-5 mb-5" *ngIf="isLoadingConfig">
      <mat-spinner diameter="40" style="margin: 0 auto;"></mat-spinner>
      <h4 class="mt-3" style="color: #b0b0b0;">Generating Voyage Config...</h4>
    </div>

    <div *ngIf="!isLoadingConfig">
      <div class="text-right">
        <mat-slide-toggle [(ngModel)]="isAutoCompleteOn">
          Auto Complete</mat-slide-toggle>
      </div>
      <br />
      <div class="row">
        <div class="col-md-2">
          <label class="date">Date:</label>
        </div>
        <div class="col-md-3">
          <label class="leg">Leg:</label>
        </div>
        <div class="col-md-3">
          <label class="report">Type of Report:</label>
        </div>
        <div class="col-md-4">
          <label class="reason">Reason:</label>
        </div>
      </div>
      <div *ngFor="let item of list; let i = index">
        <div class="row">
          <div class="col-md-2">
            <p matTooltip="{{ item.value.timestamp.split(' ')[4] }}" style="cursor: pointer; color: black;">
              {{ item.value.timestamp | date: "dd-MM-yyyy":"UTC"}}
            </p>
          </div>
          <div class="col-md-3 dropdown">
            <app-custom-dropdown [placeholder]="
              popupForm.controls['leg' + i].value ? null : 'leg' + i
            " [items]="legOptions" [controlname]="this.popupForm.controls['leg' + i]"
              (onSelectedChanged)="onSelectionChange(i, 'leg' + i, $event)"></app-custom-dropdown>
          </div>
          <div class="col-md-3 dropdown">
            <app-custom-dropdown [placeholder]="
              popupForm.controls['type' + i].value ? null : 'type' + i
            " [items]="typeOptions" [controlname]="this.popupForm.controls['type' + i]"
              (onSelectedChanged)="onSelectionChange(i, 'type' + i, $event)"></app-custom-dropdown>
          </div>
          <div class="col-md-4 textBox">
            <app-custom-input [controlname]="this.popupForm.controls['reason' + i]"
              (onSelectedChanged)="onSelectionChange(i, 'reason' + i, $event)"></app-custom-input>
          </div>
        </div>
        <br />
      </div>
    </div>
    <div class="text-center mt-4">
      <button class="btn btn-light hover-clear clear mr-2" (click)="onSubmit(true)">
        <span class="namestwo"> Next</span>
      </button>
      <button class="btn btn-light hover-clear clear mr-2" (click)="openMapModal()"
        [disabled]="isLoadingMap || !routesData">
        <span class="namestwo"> {{ isLoadingMap ? 'Loading Map...' : 'Map' }}</span>
      </button>
      <button class="btn btn-light hover-clear clear" (click)="onSubmit(false)">
        <span class="namestwo"> Cancel</span>
      </button>
    </div>
  </div>
  <div class="content" *ngIf="!nextStep">
    <div *ngIf="uploadedFile || selectedFiles.length > 0" class="uploaded-files">
      <h4>Uploaded Files:</h4>
      <div class="row" style="color: black;">
        <div *ngIf="uploadedFile" class="col-md-2">
          <button class="delete-btn" (click)="deleteFile(uploadedFile)">
            <mat-icon>close</mat-icon>
          </button>
          <div class="file-item">
            <mat-icon>insert_drive_file</mat-icon>
            <span class="uploadFileName">{{ uploadedFileName }}</span>
          </div>
        </div>
        <div *ngFor="let file of selectedFiles" class="col-md-2">
          <div class="file-item">
            <button class="delete-btn" (click)="deleteFile(file)">
              <mat-icon>close</mat-icon>
            </button>
            <mat-icon>insert_drive_file</mat-icon>
            <span class="uploadFileName">{{ file.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="text-center belowText">
      <div>
        <span class="names">Upload More Files</span>
        <button class="btn btn-light hover-clear clear btnIcons topbtn" (click)="uploadfile()">
          <mat-icon class="icon">file_upload</mat-icon>
        </button>
      </div>
      <br />
      <div>
        <span class="names">Procced To Next Step</span>
        <button class="btn btn-light hover-clear clear btnIcons" (click)="proceedClick()">
          <mat-icon class="icon">navigate_next</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <input type="file" hidden #fileInput (change)="onFileSelected($event)" accept=".xlsx, .xls , .xlsm, .csv" multiple />
</div>